<template>
  <div class="App-Streamer-Detail bg-black text-white">
    <div class="text-center loading_icon" v-show="loading">
      <vue-loading type="spin" color="#DB1016" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
    <div class="inner flex" v-show="!loading">
      <div class="left"><img :src="stList._embedded ? stList._embedded['wp:featuredmedia'][0].source_url : ''" alt="写真"/></div>
      <div class="right">
        <h1 class="h1">{{ stList.title ? stList.title.rendered :'' }}</h1>
        <div class="role text-white">{{ stList.job }}</div>
        <div class="content detail">
          <div class="text white-space-pre-wrap" v-html="stList.content ? stList.content.rendered :''"></div>
        </div>
      </div>
    </div>
    <div class="btn-wrapper" v-show="!loading">
      <button class="btn btn-white text-black d-block position-relative" @click="goback" type="submit">{{$t('btn.back')}}<span class="arrows arrows-right arrows-first border-white ml-7"></span></button>
    </div>
  </div>
</template>
<script>
  // import { mapGetters, mapState, mapActions } from 'vuex'
  import { mapGetters, mapActions } from 'vuex'
  import { VueLoading } from 'vue-loading-template'
  import { META_STREAMER_DETAIL } from '../../mixins/metadata.js'

  export default {
    mixins: [META_STREAMER_DETAIL],
    name: 'StreamerDetailPage',
    components: {
      VueLoading,
    },
    data() {
      return {
        stList: [],
      }
    },
    watch: {
      streamerAll(data) {
        const questionAnswers = _.cloneDeep(data)
        const map = _.map(questionAnswers)
        const flatten = _.flattenDeep(map)
        const num = (this.$route.params.id) * 1
        const find = _.find(flatten, { id: num })
        this.$set(this, 'stList', find)
      },
    },
    methods: {
      ...mapActions('streamer', ['getStreamerDetail', 'getStreamer', 'getStreamerAll']),
      isSameCurrentDay(date) {
        return moment(date).isSame(moment(), 'day')
      },
      goback() {
        this.$router.go(-1)
      }
    },
    computed: {
      // ...mapState('streamer', ['detail']),
      ...mapGetters('streamer', ['detail', 'loading', 'streamerAll']),
      streamerId() {
        return this.$route.params.id
      }
    },
    created() {
      this.getStreamerDetail(this.streamerId)
      this.getStreamerAll()
    },
    filters: {
      truncate(text, stop, clamp) {
        return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
      }
    },
  }
</script>
<style lang="scss" scoped>
.loading_icon{
  padding-top: 200px;
}
@media screen and (min-width:480px) {
  .loading_icon{
    padding-top: 100px;
  }
}
</style>
